<button
  type="button"
  class="login-close"
  aria-label="Close"
  (click)="modalRef.close()"
>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
  </svg>
</button>
<iframe
  *ngIf="loginUrl"
  [src]="loginUrl"
  class="login-frame"
  title="Sign in"
  (load)="onFrameLoad($event)"
></iframe>
